const translations = require('./en-GB.json')
export default async (context, locale) => {
  return await Promise.resolve({
    ...translations
  })
}
